import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Select, { components, createFilter } from 'react-select';
import './style.scss';

const filterConfig = {
  ignoreCase: true,
  ignoreAccents: true,
  trim: true,
  matchFrom: 'start'
};

const customStyles = {
  control: styles => ({
    ...styles,
    borderRadius: 0,
    boxShadow: 'hsl(0, 0%, 80%)',
    ':hover': {
      borderColor: 'hsl(0, 0%, 80%)'
    },
    ':not(:focus)': {
      borderColor: 'hsl(0, 0%, 80%)'
    }
  }),
  option: (styles, { isSelected, isFocused }) => ({
    ...styles,
    backgroundColor: isSelected ? null : isFocused ? "#ececec" : null, //eslint-disable-line
    color: isSelected ? "#4a4a4a" : isFocused ? "#4a4a4a" : null, //eslint-disable-line
    padding: '8px 20px',
    ':hover': {
      backgroundColor: isSelected ? "#fff" : isFocused ? "#ececec" : "#fff", //eslint-disable-line
      cursor: 'pointer'
    }
  }),
  valueContainer: styles => ({
    ...styles,
    height: '100%',
    maxHeight: 62,
    minHeight: 39,
    overflow: 'auto'
  }),
  menu: styles => ({
    ...styles,
    margin: 0,
    borderRadius: 0
  }),
  indicatorSeparator: styles => ({
    ...styles,
    display: 'none'
  }),
  multiValue: styles => ({
    ...styles,
    maxWidth: '95%'
  }),
  multiValueLabel: styles => ({
    ...styles,
    fontSize: 14
  }),
  multiValueRemove: (styles, state) => ({
    ...styles,
    ':hover': {
      color: 'initial',
      backgroundColor: 'initial',
      cursor: 'pointer'
    },
    display: state.data.isFixed ? 'none' : styles.display
  }),
  clearIndicator: styles => ({
    ...styles,
    ':hover': {
      color: '#4a4a4a',
      cursor: 'pointer'
    }
  }),
  dropdownIndicator: styles => ({
    ...styles,
    padding: '0 .2em',
    height: 39,
    maxHeight: '100%',
    width: 23,
    position: 'relative',
    borderLeft: '1px solid #d6d6d6',
    ':hover': {
      cursor: 'pointer'
    }
  }),
  input: styles => ({
    ...styles,
    padding: 0,
    margin: 0,
    lineHeight: '16px'
  })
};

const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <span
          style={{
            color: '#555555',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        >
          <i className='fa fa-caret-down' />
        </span>
      </components.DropdownIndicator>
    )
  );
};

const LoadingIndicator = props => {
  return (
    <span {...props}>
      <i
        className='ui-autocomplete-loader fa fa-circle-o-notch fa-spin fa-fw'
        style={{ marginRight: 10 }}
      />
    </span>
  );
};

const Group = props => {
  if (props.options[0].data === 'empty') {
    //eslint-disable-line
    return (
      <components.Group {...props}>
        <span style={{ padding: '0 20px', opacity: 0.8 }}>
          No results found.
        </span>
      </components.Group>
    );
  } else {
    return <components.Group {...props} />;
  }
};

Group.propTypes = {
  options: PropTypes.array
};

class Multiselect extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool,
    placeholder: PropTypes.string,
    onRemote: PropTypes.func,
    onChange: PropTypes.func,
    items: PropTypes.array,
    value: PropTypes.array,
    errorMessage: PropTypes.string,
    labelKey: PropTypes.string,
    className: PropTypes.string,
    valueRenderer: PropTypes.func,
    clearable: PropTypes.bool,
    removeSelected: PropTypes.bool
  };

  static defaultProps = {
    clearable: true,
    removeSelected: false
  };

  constructor(props) {
    super(props);
    this.state = {
      removeSelected: true,
      disabled: false,
      crazy: false,
      stayOpen: false,
      rtl: false,
      errorMessage: '',
      error: false
    };
  }

  toggleCheckbox(e) {
    this.setState({
      [e.target.name]: e.target.checked
    });
  }
  toggleRtl(e) {
    let rtl = e.target.checked;
    this.setState({ rtl });
  }

  handleSelectChange = value => {
    if (value.length > 0) {
      this.setState({
        error: false
      });
    }
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  onOpen = () => {
    if (this.props.onRemote) {
      this.props.onRemote();
    }
  };

  validate(val) {
    const value = val || this.props.value;
    const result = value && value.length > 0;
    this.setState({ error: !result, errorMessage: this.props.errorMessage });
    return result;
  }

  render() {
    const { disabled, stayOpen } = this.state;
    const { items, value, className } = this.props;

    const classes = classNames(className, 'multiselect margin-bottom-5', {
      'multiselect-error': this.state.error && !this.state.disabled
    });

    return (
      <div className='box-multiselect'>
        <Select
          styles={customStyles}
          components={{ DropdownIndicator, LoadingIndicator, Group }}
          filterOption={createFilter(filterConfig)}
          closeOnSelect={stayOpen}
          className={classes}
          disabled={disabled}
          isMulti
          onChange={this.handleSelectChange}
          options={items}
          placeholder={this.props.placeholder}
          hideSelectedOptions={this.props.removeSelected}
          rtl={this.state.rtl}
          value={value}
          onMenuOpen={this.onOpen}
          isLoading={this.props.isLoading}
          getOptionLabel={opt =>
            this.props.labelKey ? opt[this.props.labelKey] : opt.label
          }
          valueRenderer={this.props.valueRenderer}
          isClearable={this.props.clearable}
          closeMenuOnSelect={false}
          classNamePrefix='react-select'
        />
        <span className='error'>{this.state.errorMessage}</span>
      </div>
    );
  }
}

export default Multiselect;



// WEBPACK FOOTER //
// ./src/components/Multiselect/index.js